import React from "react";
import styles from "../Select-ItemContainer.module.css";
import {ConnectionEditTable} from "../../../Components/Table/CYNYConnection_Table";
import ColorPicker from "../../../Components/ColorPicker/ColorPicker";

export class SelectCYNYConnection extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            previousHex: null,
            newHex: null,
        }
    }

    onRefreshProps = () => {
        this.forceUpdate(() => {
            const {selectedObject, graph} = this.props;
            const style = graph.getCurrentCellStyle(selectedObject, true);
            this.setState({previousHex: style.fontColor, newHex: null});
        });
    };

    handleChange = (color) => {
        const {graph, selectedObject} = this.props;
        graph.updateConnectionsGroupColor(selectedObject, color.hex);
        this.setState({newHex: color.hex});
    };


    componentDidMount() {
        const {graph, selectedObject} = this.props;
        if (selectedObject) {
            this.setupColors();
        }
        graph.addListener('RENAME_CONNECTION', this.onRefreshProps);
        graph.addListener('COLOR_CONNECTION_CHANGE', this.onRefreshProps);
    }

    componentDidUpdate(prevProps) {
        const {selectedObject} = this.props;
        const {newHex} = this.state;
        if (prevProps.selectedObject !== selectedObject) {
            if (prevProps.selectedObject && newHex) {
                /**
                 * Reset previous connection color changes
                 */
                this.applyPreviousColorChange(prevProps.selectedObject);
            }
            this.setupColors();
        }
    }

    setupColors() {
        /**
         * Set color we started with
         */
        const {graph, selectedObject} = this.props;
        const style = graph.getCurrentCellStyle(selectedObject);
        this.setState({previousHex: style.fontColor});
    }

    applyPreviousColorChange(previousSelectedConnection) {
        const {previousHex, newHex} = this.state;
        /**
         * We need this hack because setStyles during add selection cells event breaks edge handler creation.
         * So we delay it
         */
        setTimeout(() => {
            this.applyColor(previousSelectedConnection, previousHex, newHex);
        });
        this.setState({newHex: null, previousHex: null});
    }

    componentWillUnmount() {
        const {graph, selectedObject} = this.props;
        graph.removeListener(this.refreshName);
        const {newHex, previousHex} = this.state;
        if (newHex) {
            this.applyColor(selectedObject, previousHex, newHex);
        }
    }

    applyColor(obj, previousHex, newHex) {
        const {graph} = this.props;
        /**
         * Update to the start color before setting the current in history
         * to get the right event
         */
        graph.updateConnectionsGroupColor(obj, previousHex);
        /**
         * Set to history
         */
        graph.setConnectionGroupColor(obj, newHex);
    }

    createData = () => {
        const {graph} = this.props;
        const cell = graph.getSelectionCells()[0];

        return [{
            value: cell.name,
            property: 'Name',
            key: `unique 1`
        }];
    };


    render() {
        const originData = this.createData();
        const {onUpdateConnectionData} = this.props;
        const {newHex, previousHex} = this.state;
        const color = newHex || previousHex;
        return (
            <div>
                <div className={styles.pinout_title}>
                    <span>SELECTED CONNECTION</span>
                </div>
                <ConnectionEditTable originData={originData}
                                     onUpdateConnectionData={onUpdateConnectionData}
                />
                <ColorPicker handleChange={this.handleChange}
                             color={color}
                             placement={'top'}/>
            </div>
        )
    }
}


